import { render, staticRenderFns } from "./OpenData.vue?vue&type=template&id=3c2e6b50"
import script from "./OpenData.vue?vue&type=script&lang=js"
export * from "./OpenData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports